"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Point_1 = require("../../Utility/Point");
HTMLElement.prototype.getPosition = function getPosition(relativeTo) {
    const relativePosition = relativeTo ? relativeTo.getPosition() : Point_1.default.ZERO;
    const rect = this.getBoundingClientRect();
    return new Point_1.default(rect.left + window.scrollX - relativePosition.x, rect.top + window.scrollY - relativePosition.y);
};
//# sourceMappingURL=GetPosition.js.map